<!-- NOTE:
   DO NOT REMOVE Theme container wrapper
  This wrapper div is vital to dynamic theming to work.
-->
<div id="themeContainer">
  <router-outlet></router-outlet>
</div>
